export const faqs = [
  {
    q: "韩国漫画大全收录了哪些题材类型？",
    a: "本站按韩漫大全类型整理内容，目前开设奇幻、校园、古风三大核心专题，并在专题内持续补充同类佳作。你可以通过顶部导航或首页的题材分类快速进入对应专题。",
  },
  {
    q: "奇幻专题主要推荐什么样的作品？",
    a: "韩漫大全奇幻专题涵盖异世界冒险、魔法学院、龙族与重生、超能力生存游戏等设定，偏热血战斗与宏大世界观，适合喜欢脑洞与沉浸式剧情的读者。",
  },
  {
    q: "校园专题和古风专题分别适合哪些读者？",
    a: "校园专题主打青春恋爱、日常成长与群像故事，甜度和温度并存；古风专题聚焦宫廷权谋、仙侠玄幻与古装爱恋，画风华美、意境浓郁。两者适合不同口味的读者，也可交叉浏览。",
  },
  {
    q: "专题内的作品会持续更新吗？",
    a: "会。我们会定期根据韩漫大全分类专题定位，筛选口碑良好、题材匹配的新作与完结佳作补充进对应专题，让每个专题都保持新鲜和参考价值。",
  },
  {
    q: "作品的状态（连载中 / 已完结）可信吗？",
    a: "作品标注的连载状态与章节数基于整理时的公开信息，会随作品更新而调整。连载中作品的具体更新节奏以原作者发布为准，本站仅作题材导览与推荐参考。",
  },
  {
    q: "如何向本站推荐好看的韩国漫画？",
    a: "欢迎通过“联系我们”页面给我们留言，告诉我们作品名称与题材，我们会评估后将其收录进相应的韩漫大全分类专题，与更多读者分享。",
  },
];